// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__PuVgl","instructorTitle":"style__instructorTitle__aJ9YB"};